module.exports = __webpack_public_path__ + "img/CanonVision_Web_Gallery.340f6290.gif";